import { QuestionBase } from './question-base.model';

export class ImgUploadQuestion extends QuestionBase<string> {
    controlType = 'img-upload';
    type: string;
    inputType: string;
    hasTooltip: boolean;
    tooltipTranslateKey: string;
    hasExtraLink: boolean;
    manageLink: string;
    hasExtraAction: boolean;
    actionLabel: string;

    constructor(options: {} = {}) {
        super(options);
        this.type = options['inputType'] || 'text';
        this.hasTooltip = options['hasTooltip'] || false;
        this.tooltipTranslateKey = options['tooltipTranslateKey'] || '';
        this.hasExtraLink = options['hasExtraLink'] || false;
        this.manageLink = options['manageLink'] || '';
        this.hasExtraAction = options['hasExtraAction'] || false;
        this.actionLabel = options['actionLabel'] || '';
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/components/form/models/question-img-upload.model.ts